import React, { useEffect, useState } from "react";
// import '../pages/ItemPage.css'
import {
  SetTGroupItemList,
  GetGroupItemList,
  SetGroupBackup,
  SetProductFeature,SetGroupList,
} from "../../store/itemGroupAtom";
import { itemsGroupService } from "../../services/itemGroup.service";

export default function ItemGroupDetailsScroll({ viewItemDetails }) {
  const groupList = GetGroupItemList();
  const setGList = SetGroupList();
  const setBackup = SetGroupBackup();

    const setItemGroupList = SetTGroupItemList();
    const setProductFeature = SetProductFeature();
    const setGroupBackUp = SetGroupBackup();

  const [items, setItems] = useState([]);
  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    // Load data only if atom is empty
    if (groupList.length === 0) {
      itemsGroupService.getGroupItemsList().then((res) => {
        if (res?.data?.length) {
          setItems(res.data);
          setGList(res.data);
          setBackup(res.data);
        }
      });
    } else {
      setItems(groupList);
    }
  }, [groupList]);

  const handleSelect = (groupId) => {
    setSelectedId(groupId);
    viewItemDetails(groupId);
  };


    useEffect(() => {
      if (groupList?.length < 1) {
            loadItemsFromServer();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [groupList]);
  
    function loadItemsFromServer() {
      itemsGroupService.getGroupItemsList().then((res) => {
        if (res.data) {
          setItemGroupList(res?.data?.group_info);
          setProductFeature(res?.data?.product_feature_info);
          setGroupBackUp(res?.data?.group_info);
        }
      });
    }

  return (
    <div className="h-full bg-white flex flex-col border-r">
      {/* Fixed Header */}
      <div className="px-5 py-4 border-b bg-gray-50">
        <h3 className="text-sm font-semibold text-gray-700 tracking-tight">
          Item Groups
          <span className="ml-1.5 text-gray-500 font-normal">
            ({items.length})
          </span>
        </h3>
      </div>

      {/* Scrollable List */}
      <div className="flex-1 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-50 hover:scrollbar-thumb-gray-400 transition-colors">
        {items.length === 0 ? (
          <div className="h-full flex flex-col items-center justify-center text-gray-500 text-sm px-6 text-center py-10">
            <p className="font-medium">No item groups found</p>
            <p className="mt-1 text-gray-400">Create a new group to get started</p>
          </div>
        ) : (
          <div className="divide-y divide-gray-100">
            {items.map((group) => {
              const isActive = Number(group.Item_Group_Id) == Number(selectedId);

              return (
                <div
                  key={group.Item_Group_Id}
                  onClick={() => handleSelect(group.Item_Group_Id)}
                  className={`
                    group px-5 py-3.5 cursor-pointer transition-all duration-150
                    hover:bg-indigo-50/60
                    ${isActive 
                      ? "bg-indigo-50/80 border-l-4 border-l-indigo-500 font-medium" 
                      : "hover:border-l-4 hover:border-l-indigo-300/50"}
                  `}
                >
                  <div className="flex items-center gap-3">
                    {/* Checkbox – kept but styled minimally */}
                    <input
                      type="checkbox"
                      checked={isActive}
                      onChange={() => handleSelect(group.Item_Group_Id)}
                      onClick={(e) => e.stopPropagation()}
                      className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                    />

                    {/* Group Name */}
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-medium text-gray-900 truncate">
                        {group.Item_Group_Name || "Unnamed Group"}
                      </p>

                      {/* Optional extra info */}
                      {group.Item_Group_Category_Name && (
                        <p className="text-xs text-gray-500 mt-0.5 truncate">
                          {group.Item_Group_Category_Name}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* Footer count */}
      {items.length > 0 && (
        <div className="px-5 py-2.5 bg-gray-50 border-t text-xs text-gray-500 flex justify-between items-center">
          <span>
            {items.length} {items.length === 1 ? "group" : "groups"}
          </span>
          <span className="text-gray-400">Click to view details</span>
        </div>
      )}
    </div>
  );
}